// extracted by mini-css-extract-plugin
module.exports = {"link":"_2CK-R","image":"_5hVfi","root":"_1fhTP"};